export enum GlobalsOutput {
	TIME = 'time',
	RESOLUTION = 'resolution',
	MV_POSITION = 'mvPosition',
	GL_POSITION = 'gl_Position',
	GL_FRAGCOORD = 'gl_FragCoord',
	GL_POINTCOORD = 'gl_PointCoord',
	GL_POINTSIZE = 'gl_PointSize',
	WORLD_POSITION = 'worldPosition',
	WORLD_NORMAL = 'worldNormal',
	MODEL_MATRIX = 'modelMatrix', // object.matrixWorld
	MODEL_VIEW_MATRIX = 'modelViewMatrix', // object.modelViewMatrix
	NORMAL_MATRIX = 'normalMatrix', // object.normalMatrix
}
